'use strict';

var AbstractListResultView = require('components/common/views/abstract_list_result_view');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

var templates = Misc.templateSet(require('components/profile/templates/device_report'));

module.exports = OOP.extend(
    AbstractListResultView,
    {
        initialize: function (options) {
            this.base.initialize(options);
        },

        onShow: function () {
            this.base.onShow();
            var self = this;
            setTimeout(function () {
                self.render();
            }, 200);
        },

        getTableConfiguration: function () {
            return {
                columns: [
                    { id: '#_file', name: i18n.TR('Datei'), alwaysVisible: true, displayMethod: 'file' },
                    { id: '#_created', name: i18n.TR('Erstellt am'), displayMethod: 'datetime' },
                    { id: '#_from', name: i18n.TR('Von'), displayMethod: 'datetime' },
                    { id: '#_till', name: i18n.TR('Bis'), displayMethod: 'datetime' },
                ],
                hasRefreshButton: false,
                hasSelectionButtons: false,
                displayMethods: {
                    file: function (value, model) {
                        return templates.File({
                            reportID: this.listResultInitOptions.reportID,
                            model: model,
                        });
                    },
                },
            };
        },
    },
    'DeviceReportDownloadListView'
);
